import styled from '@emotion/styled';
import classNames from 'classnames';
import { format } from 'date-fns';
import groupBy from 'lodash.groupby';
import PropTypes from 'prop-types';
import React from 'react';
import { font, mediaQueries, palette, remCalc, sizeMap } from '../../css';
import GuideProgram from '../GuideProgram/GuideProgram';

import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

const Month = styled('p')(
    {
        fontSize: remCalc(sizeMap.xs * 0.9),
        lineHeight: remCalc(sizeMap.xs * 0.9),
        fontWeight: font.weight.bold,
        width: '100%',
        backgroundColor: '#333',
        display: 'block',
        padding: remCalc(15),
        color: palette('white'),
        marginBottom: 0,
        '&::first-letter': {
            textTransform: 'uppercase',
        },

        [mediaQueries.medium]: {
            padding: remCalc(20, 50),
            fontSize: remCalc(sizeMap.l * 0.9),
            lineHeight: remCalc(sizeMap.l * 0.9),
        },
    },
    ({ isFirst }) => (isFirst ? { background: ['#333333', 'linear-gradient(to bottom, #2e2e2e, #333333)'] } : {}),
);

const GuideProgramsWrapper = styled('div')({
    padding: remCalc(0, 20),
});

const ConcertProgramTimeline = ({ className, dateLocale, programs: _programs, concertLabels }) => {
    const programsGroupedByMonth = React.useMemo(() => {
        const filteredPrograms = _programs.filter(({ availability }) => !!availability);
        return groupBy(filteredPrograms, (program) =>
            format(legacyParse(program.availability.upcomingDate), convertTokens('MMMM'), { locale: dateLocale }),
        );
    }, [_programs, dateLocale]);

    return (
        <div className={classNames('program-timeline', className)}>
            {Object.entries(programsGroupedByMonth).map(([month, programs], index) => {
                const isFirst = index === 0;
                return (
                    <div ariaLabel={`Program for ${month}`}>
                        <Month isFirst={isFirst}>{month}</Month>
                        <GuideProgramsWrapper>
                            {programs.map((programProps) => (
                                <GuideProgram
                                    domain="concert"
                                    showDate
                                    showHour
                                    key={`${programProps.programId}-ProgramTimeline`}
                                    labelType={programProps.availability.type}
                                    concertLabels={concertLabels}
                                    {...programProps}
                                />
                            ))}
                        </GuideProgramsWrapper>
                    </div>
                );
            })}
        </div>
    );
};

ConcertProgramTimeline.propTypes = {
    className: PropTypes.string,
    concertLabels: PropTypes.shape({
        onAir: PropTypes.string,
        livestream: PropTypes.string,
    }),
    dateLocale: PropTypes.shape(),
    programs: PropTypes.arrayOf(PropTypes.object),
};
ConcertProgramTimeline.defaultProps = {
    className: '',
    concertLabels: {
        onAir: '',
        livestream: '',
    },
    dateLocale: {},
    programs: [],
};

export default ConcertProgramTimeline;
